import { FunctionComponent } from 'react';
import { breakpoints } from '@ds/ui';
import { inkBackgroundTokens, inkSpacingTokens } from '@ds/tokens';
import styled from '@emotion/styled';
import breakpointSizes from 'layouts/ApplicationLayout/objects/breakpointSizes/breakpointSizes';
import { ContainerLayoutFooterButtons, ContainerLayoutFooterDisclaimer } from './components';

type ContainerLayoutFooterType = {
    Buttons: typeof ContainerLayoutFooterButtons;
    Disclaimer: typeof ContainerLayoutFooterDisclaimer;
} & FunctionComponent;

const ContainerLayoutFooterContainer = styled.div`
    margin-top: ${inkSpacingTokens.spacingXS};
    background-color: ${inkBackgroundTokens.bgColorDefault};

    .container {
        border-top: 1px solid #d9d9e0;
        display: flex;
        justify-content: end;
        align-items: center;

        padding: ${inkSpacingTokens.spacingXS} 0;
    }

    // MOBILE - WIDTH
    ${breakpoints.lessThan(breakpointSizes.xs)} {
        .container {
            border: none;
            flex-direction: column;
            align-items: inherit;
        }

        bottom: 0;
        width: 100%;
    }
`;

const ContainerLayoutFooter: ContainerLayoutFooterType = ({ children }) => (
    <ContainerLayoutFooterContainer>
        <div className="container">{children}</div>
    </ContainerLayoutFooterContainer>
);

ContainerLayoutFooter.Buttons = ContainerLayoutFooterButtons;
ContainerLayoutFooter.Disclaimer = ContainerLayoutFooterDisclaimer;

export default ContainerLayoutFooter;
